// Invisible layout containers: no handle, no hover tint, no drop indicator
export const isLayoutContainer = (block) =>
  block.type === 'row' || block.type === 'column' || block.type === 'choice-path';

// Blocks that read as a visual "box" — used for consistent stacking gaps
// (callout-on-callout, code-on-code, code-on-callout, … → .stack-callout-*)
export const BOXY_TYPES = [
  'callout',
  'choice',
  'row',
  'table',
  'code',
  'image',
  'video',
  'variables',
  'linked-variable-row',
  'snippet',
  'file-upload',
];

export const blockWrapperClassName = ({
  block,
  inTableCell,
  selected,
  multiSelected,
  isDragging,
  prevType,
  nextType,
}) =>
  [
    'block-wrapper',
    inTableCell ? 'block-wrapper--cell' : '',
    block.type === 'row' ? 'row-block-wrapper' : '',
    block.type === 'column' ? 'column-block-wrapper' : '',
    selected ? 'selected' : '',
    multiSelected ? 'multi-selected' : '',
    isDragging ? 'dragging' : '',
    // "Boxy" blocks (callouts, and rows — whose visible edges are the
    // callouts inside their columns) stacked on each other: the vertical
    // gap matches the 18px horizontal column gap (blocks.css
    // .stack-callout-*)
    BOXY_TYPES.includes(block.type) && BOXY_TYPES.includes(prevType)
      ? 'stack-callout-above'
      : '',
    BOXY_TYPES.includes(block.type) && BOXY_TYPES.includes(nextType)
      ? 'stack-callout-below'
      : '',
  ]
    .filter(Boolean)
    .join(' ');
